import { useEffect } from 'react';

import { useFetcher } from '@remix-run/react';

const useRecommendations = () => {
  const fetcher = useFetcher();

  useEffect(() => {
    fetcher.load('/recommendations?index');
  }, []);

  return {
    recommendations: fetcher?.data,
  };
};

export default useRecommendations;
